import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AutocompleteComponent} from '../autocomplete/autocomplete.component';
import {FormElementsService} from '../../services/form-elements.service';
import {StudyProgrammeProfession} from '../../../forms/modules/sp/models/osp';

@Component({
  selector: 'app-autocomplete-select',
  templateUrl: './autocomplete-select.component.html',
  styleUrls: ['./autocomplete-select.component.scss']
})
export class AutocompleteSelectComponent extends AutocompleteComponent implements OnInit {
  @Input() isAddProfession = false;
  @Output() inputValidationState = new EventEmitter();
  @Output() professionAdded = new EventEmitter();
  @ViewChild('inputElement') inputElement: ElementRef;
  public initialString: string;

  constructor(protected formElementsService: FormElementsService) {
    super(formElementsService);
  }

  ngOnInit(): void {
    this.actualValue = this.ngModelObject;
    if (this.getObjectProperty()) {
      this.initialString = JSON.parse(JSON.stringify(this.getObjectProperty()));
    }
  }

  public setSelectedOption(event?: any): void {
    const valueToEmit = this.getValueToEmit(event);
    switch (this.inputId) {
      case 'StudyProgramme.profession':
        const profession = event ? valueToEmit as StudyProgrammeProfession : this.getEmptyProfession();
        this.emitValue(profession, this.objectToSet);
        break;
      default:
        this.emitValue(valueToEmit, this.objectToSet);
    }
    this.inputValidationState.emit(true);
  }

  public checkInputValidity(): void {
    this.inputValidationState.emit(this.inputElement.nativeElement.classList.contains('ng-valid'));
  }

  public addProfession(): void {
    this.professionAdded.emit();
  }

  private getEmptyProfession(): StudyProgrammeProfession {
    return {
      idStudyProgrammeProfession: null,
      idSustavaPovolaniEmployment: null,
      idSustavaPovolaniArea: null,
      idSkiscoEmployment: null,
      name: null
    };
  }
}
